/**
 * HTTP-statusen ur ett okänt fel.
 *
 * Egen hjälpare därför att alternativet är `catch (fel: any)` på varje anropsplats,
 * vilket både bryter mot projektets lint-regler och tyst tillåter stavfel i
 * `fel.response.status`. `unknown` tvingar fram kontrollen en gång, här.
 */
export function httpStatus(fel: unknown): number | undefined {
  if (typeof fel !== 'object' || fel === null) {
    return undefined;
  }
  const svar = (fel as { response?: unknown }).response;
  if (typeof svar !== 'object' || svar === null) {
    return undefined;
  }
  const status = (svar as { status?: unknown }).status;
  return typeof status === 'number' ? status : undefined;
}

/**
 * Sant när felet betyder "den här endpointen finns inte ännu" — 404 eller 501.
 * Används för de ytor som väntar på att backend byggs.
 */
export function ärEjByggdEndpoint(fel: unknown): boolean {
  const status = httpStatus(fel);
  return status === 404 || status === 501;
}
